$ = require 'jquery'
Data = require '../data'
{ parse } = require '../../components/query-string'

hasPushState = window.history and history.pushState

getQuery = ->
  if hasPushState
    location.search.replace('?', '')
  else
    location.hash.match(/^.*\?(.*)$/)?[1]

module.exports =

  getQuery: ->
    getQuery()

  getParams: ->
    query = getQuery()
    if query then parse(query) else {}

  getParam: (name) ->
    parse(getQuery())[name]

  addParam: (i, name, val) ->
    Data.params[i][name] = val

  deleteParam: (i, name) ->
    delete Data.params[i][name]

  saveParams: (i, params) ->
    if typeof params is 'string'
      params = parse params.replace('?', '')
    Data.params[i] = params



// WEBPACK FOOTER //
// ./webpack/requires/pc/views/params.coffee